// extracted by mini-css-extract-plugin
module.exports = {"layout":"DefaultLayout_layout__2Bg6b"};